import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { PlacementContext } from 'src/types/PlacementContext';

export const trackImpression = (placementContext: PlacementContext) => {
  const { trackingPosition, trackingTitle } = placementContext;

  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${trackingPosition} | Copy block`,
    event_label: `${trackingPosition} | ${trackingTitle}`.toLowerCase(),
    event_name: 'view_content',
    content_position: `${trackingPosition}`,
    content_type: `copy block|${trackingTitle}`.toLowerCase(),
  });
};

export const trackLinkClick = async (e: React.MouseEvent, placementContext: PlacementContext) => {
  e.preventDefault();
  const { textContent, href, target } = e.target as HTMLAnchorElement;
  const { trackingPosition, trackingTitle } = placementContext;

  await sendGAEvent({
    event: 'custom_event',
    event_action: 'Link click',
    event_category: `${trackingPosition} | Copy block`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${textContent}`.toLowerCase(),
    event_name: 'select_content',
    event_details: 'link click',
    content_position: `${trackingPosition}`,
    content_type: `copy block|${trackingTitle}`.toLowerCase(),
    destination_URL: href,
    item_id: `${textContent}`.toLowerCase(),
  });
  window.open(href, target);
};
